/**
 * Created by zhj on 3/25/2016.
 */
'use strict';

angular.module('dashboard.digitalOutputs', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('digitalOutputsWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.driverWhrkHrsSVG.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.driverWhrkHrsSVG.description';
          }
        },
        controller: 'digitalOutputsCtrl',
        templateUrl: 'components/dashboard/digitalOutputs/digitalOutputsWidget.tpl.html',
        isSingleInstance: true,
        config: {
          statusCodeList: [],
          vehicleList: [],
          vehicleGroup: null,
          vehicleGroupList: [],
          statusCode: null,
          noOfGridRows: ''
        }
      });
  }).service('digitalOutputsService', function (crudService) {
  this.saveDigitalOutPut = function (param) {
    return crudService.post('portalcommands/digitaloutput', param);
  };
}).controller('digitalOutputsCtrl', function ($scope, digitalOutputsService, $rootScope, toastService) {
  $scope.flag1 = true;
  $scope.flag2 = true;
  $scope.flag3 = true;
  $scope.flag4 = true;

  $scope.digitalOutputsDetail = {
    deviceID: '',
    firstCheck: false,
    secondCheck: false,
    thirdCheck: false,
    fourthCheck: false,
    switchStatus1: false,
    switchStatus2: false,
    switchStatus3: false,
    switchStatus4: false,
    timeout1: null,
    timeout2: null,
    timeout3: null,
    timeout4: null
  };

  $scope.checkboxChange = function (index, value) {
    switch (index) {
      case 1:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus1 = false;
          $scope.digitalOutputsDetail.timeout1 = null;
        }
        $scope.flag1 = !value;
        break;
      case 2:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus2 = false;
          $scope.digitalOutputsDetail.timeout2 = null;
        }
        $scope.flag2 = !value;
        break;
      case 3:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus3 = false;
          $scope.digitalOutputsDetail.timeout3 = null;
        }
        $scope.flag3 = !value;
        break;
      case 4:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus4 = false;
          $scope.digitalOutputsDetail.timeout4 = null;
        }
        $scope.flag4 = !value;
        break;
    }
  };

  $scope.switchChange = function (index, value) {
    if (!value) {
      switch (index) {
        case 1:
          $scope.digitalOutputsDetail.timeout1 = null;
          break;
        case 2:
          $scope.digitalOutputsDetail.timeout2 = null;
          break;
        case 3:
          $scope.digitalOutputsDetail.timeout3 = null;
          break;
        case 4:
          $scope.digitalOutputsDetail.timeout4 = null;
          break;
      }
    }
  };

  $scope.$on('vehiclesListRowSelected', function (event, args) {
    if (args) {
      var broadcastEventData = args;
      var selectedRow = broadcastEventData.selectedRow;
      if (!selectedRow) {
        $scope.isDataAvailable = false;
        return;
      }
      $scope.isDataAvailable = true;
      $scope.digitalOutputsDetail.deviceID = selectedRow.deviceid;
      $scope.digitalOutputsDetail.firstCheck = false;
      $scope.digitalOutputsDetail.secondCheck = false;
      $scope.digitalOutputsDetail.thirdCheck = false;
      $scope.digitalOutputsDetail.fourthCheck = false;
      $scope.digitalOutputsDetail.switchStatus1 = selectedRow.outputbit[0].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.switchStatus2 = selectedRow.outputbit[1].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.switchStatus3 = selectedRow.outputbit[2].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.switchStatus4 = selectedRow.outputbit[3].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.timeout1 = null;
      $scope.digitalOutputsDetail.timeout2 = null;
      $scope.digitalOutputsDetail.timeout3 = null;
      $scope.digitalOutputsDetail.timeout4 = null;
      $scope.flag1 = true;
      $scope.flag2 = true;
      $scope.flag3 = true;
      $scope.flag4 = true;
    } else {
      $scope.isDataAvailable = false;
    }
  });

  $scope.save = function () {
    var digitalOutPutParams = {
      deviceID: $scope.digitalOutputsDetail.deviceID,
      commandType: 'GTSDO',
      sendState: 0,
      commandArgs: ''
    };
    var object = {
      DO: {}
    };
    if ($scope.digitalOutputsDetail.firstCheck) {
      object.DO[1] = {
        value: $scope.digitalOutputsDetail.switchStatus1 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout1
      };
    }
    if ($scope.digitalOutputsDetail.secondCheck) {
      object.DO[2] = {
        value: $scope.digitalOutputsDetail.switchStatus2 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout2
      };
    }
    if ($scope.digitalOutputsDetail.thirdCheck) {
      object.DO[3] = {
        value: $scope.digitalOutputsDetail.switchStatus3 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout3
      };
    }
    if ($scope.digitalOutputsDetail.fourthCheck) {
      object.DO[4] = {
        value: $scope.digitalOutputsDetail.switchStatus4 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout4
      };
    }
    digitalOutPutParams.commandArgs = JSON.stringify(object);

    return digitalOutputsService.saveDigitalOutPut(digitalOutPutParams).then(function () {
      $rootScope.$broadcast('portalCommandSaved');
      toastService.showSuccessToast('Save Successfully!');
    }, function (response) {
      var errorAlert = {type: 'F', message: response.data.message};
      toastService.showErrorToast(errorAlert);
    });
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/digitalOutputs/digitalOutputsWidget.js